<template>
	<li>
		<a :href="cafeInfo.contents.url" class="link_recommend" target="_blank">
			<div class="box_type_bg">
				<img :src="cafeInfo.contents.image" class="img_thumb" alt="">
				<span class="thumb_frame"></span>
				<div class="box_tbl">
					<div class="inner_tbl">
						<strong class="tit_name">{{ content }}</strong>
						<span class="txt_info">
							<span v-if="cafeInfo.popularCafe" class="icon pop_ico">인기</span>
							<span v-else class="icon rec_ico">추천</span>
							<span class="title">{{ cafeInfo.contents.title }}</span>
						</span>
					</div>
				</div>
			</div>
		</a>
	</li>
</template>

<script>
export default {
	props: ['cafeInfo'],
	computed: {
		content() {
			return this.cafeInfo.contents.content.replace(/<br>/g, ' ');
		}
	}
}
</script>
